// Angular import
import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// Project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { LayoutService } from 'src/app/@theme/services/layout.service';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { faCircle, faDotCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  // public props
  @Input() item!: NavigationItem;
  faDot: IconProp=faCircle;

  // Constructor
  constructor(
    private layoutService: LayoutService,
    private sanitizer: DomSanitizer
  ) {}

  // public method
  // Modifica del metodo toggleMenu per mantenere aperti i menu genitori
toggleMenu(event: MouseEvent) {
  if (window.innerWidth < 1025) {
    this.layoutService.toggleSideDrawer();
  }

  const ele = event.target as HTMLElement;
  if (ele !== null && ele !== undefined) {
    const parent = ele.closest('.coded-hasmenu') as HTMLElement;
    
    if (parent) {
      // Rimuovi 'active' e 'coded-trigger' solo dai menu che non fanno parte della gerarchia
      const sections = document.querySelectorAll('.coded-hasmenu');
      sections.forEach((section) => {
        if (!section.contains(parent)) {
          section.classList.remove('active');
          section.classList.remove('coded-trigger');
        }
      });

      // Aggiungi 'active' e 'coded-trigger' ai menu selezionati e ai genitori
      let current = parent as HTMLElement;
      while (current) {
        if (current.classList.contains('coded-hasmenu')) {
          current.classList.add('active', 'coded-trigger');
        }
        current = current.parentElement?.closest('.coded-hasmenu') as HTMLElement;
      }
    }
  }
}


  sanitizeURL(url: string): SafeUrl {
    // Validate and sanitize the URL here
    // For example, check if it starts with 'http://' or 'https://'
    // If it's valid, return the sanitized URL
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  isSelected(item: NavigationItem): boolean {
    // Logica per determinare se l'elemento è selezionato
    return true;
  }
}
